import { render, staticRenderFns } from "./TabsSidebar.vue?vue&type=template&id=0cb5c929&"
import script from "./TabsSidebar.vue?vue&type=script&lang=js&"
export * from "./TabsSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports